/* eslint-disable @angular-eslint/directive-selector */
import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: 'mat-checkbox, input[mat-checkbox]',
  standalone: true,
})
export class MatCheckboxAddonsDirective {
  @Input() compact: boolean = false;

  @HostBinding('class.mat-mdc-checkbox-compact') get isCompact() {
    return this.compact;
  }
}
